'use client';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoLink from 'eco-design/base/eco-link';
import { useState } from 'react';
import './index.scss';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, list, bgColor = '#f5f5f6' } = data;
    const prefixCls = 'index-notice-board';
    const [active, setAcitve] = useState(0);

    const handleClickText = (i: number) => {
        const dom: HTMLParagraphElement | null = document.querySelector(`#editor-${id} .${prefixCls}-item-${i} .${prefixCls}-item-text`);
        if (dom) {
            dom.classList.contains('open') ? dom.classList.remove('open') : dom.classList.add('open');
        }
    };

    return (
        <GloLayout
            className={`editor-${prefixCls} editor-${prefixCls}-${id}`}
            id={id}
            data={data}
            floorName={`${prefixCls}`}
            style={{ backgroundColor: bgColor }}
        >
            <div className={`${prefixCls}-wrapper`}>
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <div className={`${prefixCls}-box`}>
                    <ul className={`${prefixCls}-tabs`}>
                        {list?.map((li: any, i: number) => (
                            <li className={`${prefixCls}-tab ${active === i ? 'active' : ''}`} key={i} onClick={() => setAcitve(i)}>
                                {li.tab}
                            </li>
                        ))}
                    </ul>
                    <ul className={`${prefixCls}-items`}>
                        {list?.[active]?.items?.map((item: any, i: number) => (
                            <li className={`${prefixCls}-item ${prefixCls}-item-${i}`} key={i}>
                                <p className={`${prefixCls}-item-date`}>{item.date}</p>
                                {!item?.url ? (
                                    <div className={`${prefixCls}-item-text`} onClick={() => handleClickText(i)}>
                                        <p className="inner">{item.text}</p>
                                    </div>
                                ) : (
                                    <EcoLink className={`${prefixCls}-item-text`} href={item?.url} onClick={() => handleClickText(i)}>
                                        <span className="inner">{item.text}</span>
                                    </EcoLink>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                {list?.[active]?.linkText && list?.[active]?.linkUrl && (
                    <EcoLink className={`${prefixCls}-link`} href={list?.[active]?.linkUrl} aria-label={list?.[active]?.linkText}>
                        <span>{list?.[active]?.linkText}</span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 5L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </EcoLink>
                )}
            </div>
        </GloLayout>
    );
}
